/* Motor de las landings (árabes, diseñador, nicho). Cada sección dice sobre qué
   grupo trabaja con data-gp-grupo, así la misma página sirve para las tres y la
   clienta puede armar una nueva desde el personalizador sin tocar código. */
(function () {
  var P = GP.productos, esc = GP.esc, clp = GP.fmt, foto = GP.foto, url = GP.url;
  var $ = GP.$, $$ = GP.$$;

  var GRUPO = {
    arabe:       function (p) { return p.k === 'arabe'; },
    disenador:   function (p) { return p.k === 'disenador'; },
    nicho:       function (p) { return p.k === 'nicho'; },
    'nicho-cat': function (p) { return p.k === 'nicho'; },
    tester:      function (p) { return !!p.te; },
    '':          function () { return true; }
  };
  function grupo(el) {
    var f = GRUPO[(el && el.getAttribute('data-gp-grupo')) || ''] || GRUPO[''];
    return P.filter(f);
  }
  function num(el, attr, x) { var v = el && +el.getAttribute(attr); return v > 0 ? v : x; }

  GP.pintarDatos();

  /* ---------- mosaico de la portada ---------- */
  var mosaico = $('#mosaico');
  if (mosaico) {
    // una fragancia por casa: los más caros de un grupo suelen ser tres tamaños del mismo frasco
    var vistas = {};
    mosaico.innerHTML = grupo(mosaico).filter(function (p) { return p.img; })
      .sort(function (a, b) { return b.p - a.p; })
      .filter(function (p) { if (vistas[p.b]) return false; vistas[p.b] = 1; return true; }).slice(0, 3)
      .map(function (p) {
        return '<a href="' + url(p) + '"><div><img src="' + foto(p) + '" alt="' + esc(p.n) + '" loading="lazy">' +
          '<span>' + clp(p.p) + '</span></div></a>';
      }).join('');
  }

  /* ---------- pares de dupe ---------- */
  var cajaDupes = $('#dupes');
  if (cajaDupes) {
    var pares = P.map(function (p) { var e = GP.equiv(p); return e ? { p: p, e: e } : null; })
      .filter(Boolean).sort(function (a, b) { return b.e.pct - a.e.pct; })
      .slice(0, num(cajaDupes, 'data-gp-pares', 6));
    cajaDupes.innerHTML = pares.map(function (x) {
      var p = x.p, o = x.e.o;
      function cara(q, rotulo, ml) {
        return '<a class="dupe__cara" href="' + url(q) + '"><img src="' + foto(q) + '" alt="' + esc(q.n) + '" loading="lazy">' +
          '<small>' + rotulo + '</small><strong>' + esc(q.n) + '</strong><b>' + clp(q.p) + '</b>' +
          '<small style="text-transform:none;letter-spacing:.02em">' + q.ml + ' ml · ' + clp(Math.round(ml)) + ' el ml</small></a>';
      }
      return '<article class="dupe__par"><div class="dupe__caras">' +
        cara(p, 'El dupe', x.e.mlA) + '<div class="dupe__vs">VS</div>' + cara(o, 'El original', x.e.mlB) +
        '</div><div class="dupe__pie"><span>Dupe declarado de ' + esc(p.ins) + '</span>' +
        '<span>El mililitro cuesta <b>' + x.e.pct + '% menos</b></span></div></article>';
    }).join('');
  }

  /* ---------- tabla de dupes ---------- */
  var tabla = $('#tablaRef');
  if (tabla) {
    var conRef = P.filter(function (p) { return p.ins; });
    function pintarTabla(filtro) {
      var f = GP.sinAcento(filtro || '');
      var l = conRef.filter(function (p) { return !f || GP.sinAcento(p.n + ' ' + p.ins).indexOf(f) >= 0; })
        .sort(function (a, b) { return a.n.localeCompare(b.n, 'es'); });
      tabla.innerHTML = l.length ? l.map(function (p) {
        return '<tr><td><a href="' + url(p) + '"><div class="tp">' + (foto(p) ? '<img src="' + foto(p) + '" alt="">' : '') +
          '<div><strong>' + esc(p.n) + '</strong><span>' + esc(p.b || '') + '</span></div></div></a></td>' +
          '<td>' + esc(p.ins) + '</td><td>' + (p.ml ? p.ml + ' ml' : '—') + '</td>' +
          '<td><b>' + clp(p.p) + '</b></td><td>' + (p.ml ? clp(Math.round(p.p / p.ml)) : '—') + '</td>' +
          '<td><button class="mchip" type="button" data-add="' + p.i + '">Agregar</button></td></tr>';
      }).join('') : '<tr><td colspan="6" style="color:var(--tinta-3)">No hay dupes con ese texto.</td></tr>';
    }
    pintarTabla('');
    var busca = $('#buscaRef');
    if (busca) busca.addEventListener('input', function () { pintarTabla(this.value); });
  }

  /* ---------- las casas ---------- */
  var casas = $('#casas');
  if (casas) {
    var deGrupo = GRUPO[casas.getAttribute('data-gp-grupo') || ''] || GRUPO[''];
    var lista = GP.marcaTop(num(casas, 'data-gp-cuantas', 16), deGrupo);
    if (casas.getAttribute('data-gp-estilo') === 'pasos') {
      casas.innerHTML = lista.map(function (m) {
        // los suyos son los del mismo grupo que se contó arriba; si no, sale "0 en frasco"
        var suyos = P.filter(function (p) { return p.b === m.n && deGrupo(p); });
        var desde = suyos.length ? Math.min.apply(null, suyos.map(function (p) { return p.p; })) : 0;
        var l = GP.marcaLogo(m.n);
        var muestra = suyos.filter(function (p) { return p.img; }).sort(function (a, b) { return b.p - a.p; })[0];
        return '<a class="paso" href="' + GP.T({ m: m.n }) + '" style="display:grid;grid-template-columns:82px 1fr;gap:16px;align-items:center">' +
          '<span style="background:#fff;border:1px solid var(--linea);border-radius:2px;aspect-ratio:1;display:flex;align-items:center;justify-content:center;padding:8px">' +
            (muestra ? '<img src="' + foto(muestra) + '" alt="" loading="lazy" style="max-height:100%;object-fit:contain">' : '') + '</span>' +
          '<span>' +
            (l ? '<img src="' + l + '" alt="' + esc(m.n) + '" loading="lazy" style="height:44px;width:auto;max-width:100%;object-fit:contain;mix-blend-mode:multiply;margin-bottom:6px">'
               : '<strong style="font-size:15px;display:block;margin-bottom:4px">' + esc(m.n) + '</strong>') +
            '<span style="font-size:12.5px;color:var(--tinta-2);display:block">' + suyos.length +
            (suyos.length === 1 ? ' referencia' : ' referencias') +
            (desde ? ' · desde ' + clp(desde) : '') + '</span></span></a>';
      }).join('');
    } else {
      casas.innerHTML = lista.map(function (m) {
        var l = GP.marcaLogo(m.n);
        return '<a class="marca" href="' + GP.T({ m: m.n }) + '">' +
          (l ? '<img src="' + l + '" alt="' + esc(m.n) + '" loading="lazy">' : esc(m.n)) +
          '<span>' + m.c + ' referencias</span></a>';
      }).join('');
    }
  }

  /* ---------- tramos de precio ---------- */
  var tramos = $('#tramos');
  if (tramos) {
    var defs = $$('script[data-gp-tramo]', tramos).map(function (s) {
      var r = (s.getAttribute('data-gp-tramo') || '0-0').split('-');
      var d = {};
      try { d = JSON.parse(s.textContent); } catch (e) {}
      return { min: +r[0] || 0, max: +r[1] || 1e9, t: d.t || '', img: d.img || '' };
    });
    tramos.innerHTML = defs.map(function (t) {
      var l = P.filter(function (p) { return p.p >= t.min && p.p < t.max; });
      var marcas = GP.marcaTop(3, function (p) { return p.p >= t.min && p.p < t.max; })
                     .map(function (m) { return m.n; }).join(' · ');
      return '<a class="fam" href="' + GP.T({ min: t.min, max: (t.max < 1e9 ? t.max : 0) }) + '">' +
        (t.img ? '<img src="' + t.img + '" alt="" loading="lazy">' : '') +
        '<b>' + esc(t.t) + '</b><span>' + l.length + ' fragancias</span>' +
        '<p class="fam__notas">' + esc(marcas || '—') + '</p></a>';
    }).join('');
  }

  /* ---------- selector de notas ---------- */
  var notasSel = $('#notasSel'), notasRes = $('#notasRes');
  if (notasSel && notasRes) {
    var base = grupo(notasSel);
    var cuenta = {};
    base.forEach(function (p) { GP.notasDe(p).forEach(function (x) { cuenta[x] = (cuenta[x] || 0) + 1; }); });
    var top = Object.keys(cuenta).sort(function (a, b) { return cuenta[b] - cuenta[a]; })
                .slice(0, num(notasSel, 'data-gp-cuantas', 18));
    var elegidas = [];
    function pintarNotas() {
      notasSel.innerHTML = top.map(function (x) {
        return '<button class="fchip" type="button" data-n="' + esc(x) + '" aria-pressed="' +
          (elegidas.indexOf(x) >= 0) + '">' + esc(x) + ' ' + cuenta[x] + '</button>';
      }).join('');
      if (!elegidas.length) {
        notasRes.innerHTML = '<p style="color:var(--tinta-3);margin:0">Marca una o más notas para ver qué fragancias las llevan.</p>';
        return;
      }
      var r = base.filter(function (p) {
        var suyas = GP.notasDe(p);
        return elegidas.every(function (x) { return suyas.indexOf(x) >= 0; });
      }).sort(function (a, b) { return a.p - b.p; });
      notasRes.innerHTML = r.length
        ? '<p style="margin:0 0 14px;color:var(--tinta-2)">' + r.length + ' con ' + elegidas.join(' y ') + '</p>' +
          GP.grid(r.slice(0, 10))
        : '<p style="margin:0;color:var(--tinta-3)">Ninguna lleva todas esas notas a la vez. Prueba con una menos.</p>';
    }
    notasSel.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-n]'); if (!b) return;
      var x = b.getAttribute('data-n'), k = elegidas.indexOf(x);
      if (k >= 0) elegidas.splice(k, 1); else elegidas.push(x);
      pintarNotas();
    });
    pintarNotas();
  }

  /* ---------- catálogo con filtros ---------- */
  /* Si la página trae la barra lateral, el catálogo lo maneja gp-tienda.js con sus
     filtros completos; acá no se toca para que no se pisen. */
  var chips = $('#chips'), grid = $('#grid'), masbtn = $('#masbtn');
  if (chips && grid && !document.getElementById('panelFiltros')) {
    var TODOS = grupo(chips);
    var PASO = num(chips, 'data-gp-paso', 20), visto = PASO, filtro = 'todas';
    var ORDEN = {
      caro:   function (a, b) { return b.p - a.p; },
      barato: function (a, b) { return a.p - b.p; },
      nuevo:  function (a, b) { return b.i - a.i; }
    };
    var ordena = ORDEN[chips.getAttribute('data-gp-orden')] || ORDEN.caro;
    var CHIPS = [
      ['todas', 'Todas', function () { return true; }],
      ['dupe', 'Con dupe', function (p) { return !!p.ins; }],
      ['tester', 'Testers', function (p) { return p.te; }],
      ['hombre', 'Hombre', function (p) { return p.g === 'Hombre'; }],
      ['mujer', 'Mujer', function (p) { return p.g === 'Mujer'; }],
      ['unisex', 'Unisex', function (p) { return p.g === 'Unisex'; }]
    ].filter(function (c) {
      return c[0] === 'todas' || TODOS.some(function (p) { return p.img && c[2](p); });
    });
    function pintarCat() {
      chips.innerHTML = CHIPS.map(function (c) {
        var n = TODOS.filter(function (p) { return p.img && c[2](p); }).length;
        return '<button class="fchip" type="button" data-c="' + c[0] + '" aria-pressed="' + (c[0] === filtro) + '">' +
          c[1] + ' ' + n + '</button>';
      }).join('');
      var f = CHIPS.filter(function (c) { return c[0] === filtro; })[0][2];
      var r = TODOS.filter(function (p) { return p.img && f(p); }).sort(ordena);
      var tCat = $('#tCat');
      if (tCat) tCat.textContent = r.length + ' en vitrina';
      grid.innerHTML = GP.grid(r.slice(0, visto));
      if (masbtn) {
        masbtn.innerHTML = visto < r.length
          ? '<button class="btn btn--linea" type="button" id="mas">Ver más (' + (r.length - visto) + ' restantes)</button>' : '';
        var m = $('#mas');
        if (m) m.addEventListener('click', function () { visto += PASO; pintarCat(); });
      }
    }
    chips.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-c]'); if (!b) return;
      filtro = b.getAttribute('data-c'); visto = PASO; pintarCat();
    });
    pintarCat();
  }
})();
